module.exports = __webpack_public_path__ + "static/media/Experience Image.bb840d34.png";